import type { EvaluationTypeValue } from '@/constants/cycle-evaluation/CycleEvaluation';
import type { QuestionTypeValue } from '@/constants/QuestionType';
import type { ReviewQuestion } from '@/types/review/ReviewQuestion';

import { EvaluationType } from '@/constants/cycle-evaluation/CycleEvaluation';
import { QuestionType } from '@/constants/QuestionType';

const scoringQuestionTypes: QuestionTypeValue[] = [
    QuestionType.MULTI_CHOICE,
    QuestionType.EMOJI_CHOICE,
    QuestionType.RATING_SCALE,
    QuestionType.YES_NO,
];

type NormalizeTemplateQuestionScoringOptions = {
    question: ReviewQuestion;
    reviewType: EvaluationTypeValue;
};

export const normalizeTemplateQuestionScoring = ({
    question,
    reviewType,
}: NormalizeTemplateQuestionScoringOptions): ReviewQuestion => ({
    ...question,
    isIncludedInScoreCalculation:
        reviewType === EvaluationType.MANAGER_EVALUATION &&
        Boolean(question.companyValueId) &&
        scoringQuestionTypes.includes(question.questionType),
});
